import api from "../../utils/apiUserTienda";

export function subirHeroImagenTiendaSetup(file) {
  const fd = new FormData();
  fd.append("hero_imagen", file);
  return api
    .post("/api/tienda/setup/inicio/hero-imagen", fd)
    .then((response) => ({
      ok: true,
      data: response.data?.data ?? null,
      message: response.data?.message || "",
    }))
    .catch((error) => ({
      ok: false,
      data: null,
      message: error?.message || "No se pudo subir la imagen.",
    }));
}

function wrapGet(promise, fallbackMsg) {
  return promise
    .then((response) => ({
      ok: true,
      data: response.data?.data ?? null,
      message: response.data?.message || "",
    }))
    .catch((error) => ({
      ok: false,
      data: null,
      message: error?.message || fallbackMsg,
    }));
}

function wrapPut(promise, fallbackMsg) {
  return promise
    .then((response) => ({
      ok: true,
      message: response.data?.message || "Guardado correctamente.",
    }))
    .catch((error) => ({
      ok: false,
      message: error?.message || fallbackMsg,
    }));
}

function wrapPost(promise, fallbackMsg) {
  return promise
    .then((response) => ({
      ok: true,
      data: response.data?.data ?? null,
      message: response.data?.message || "",
    }))
    .catch((error) => ({
      ok: false,
      data: null,
      message: error?.message || fallbackMsg,
    }));
}

export function obtenerRedesSocialesSetup() {
  return wrapGet(
    api.get("/api/tienda/setup/redes-sociales"),
    "No se pudieron cargar las redes sociales."
  );
}

export function actualizarRedesSocialesSetup(body) {
  return wrapPut(
    api.put("/api/tienda/setup/redes-sociales", body),
    "No se pudieron guardar las redes sociales."
  );
}

export function obtenerHistorialContenidoLegal(tipoDocumentoId) {
  return wrapGet(
    api.get("/api/tienda/setup/contenido-legal", {
      params: { tipo_documento_id: tipoDocumentoId },
    }),
    "No se pudo cargar el historial de contenido legal."
  );
}

export function crearContenidoLegalSetup(body) {
  return wrapPost(
    api.post("/api/tienda/setup/contenido-legal", body),
    "No se pudo crear el documento legal."
  );
}

export function actualizarContenidoLegalSetup(body) {
  return wrapPut(
    api.put("/api/tienda/setup/contenido-legal", body),
    "No se pudo guardar el contenido legal."
  );
}

export function obtenerConfiguracionTiendaSetup() {
  return wrapGet(
    api.get("/api/tienda/setup/configuracion"),
    "No se pudo cargar la configuración de la tienda."
  );
}

export function actualizarConfiguracionTiendaSetup(body) {
  return wrapPut(
    api.put("/api/tienda/setup/configuracion", body),
    "No se pudo guardar la configuración de la tienda."
  );
}

export function obtenerBrandingTiendaSetup() {
  return wrapGet(
    api.get("/api/tienda/setup/branding"),
    "No se pudo cargar el branding."
  );
}

export function actualizarBrandingTiendaSetup(body) {
  return wrapPut(
    api.put("/api/tienda/setup/branding", body),
    "No se pudo guardar el branding."
  );
}

export function subirLogoTiendaSetup(file) {
  const fd = new FormData();
  fd.append("logo_tienda", file);
  return wrapPost(
    api.post("/api/tienda/setup/branding/logo", fd),
    "No se pudo subir el logo."
  );
}

export function quitarLogoTiendaSetup() {
  return wrapPost(
    api.delete("/api/tienda/setup/branding/logo"),
    "No se pudo quitar el logo."
  );
}

export function obtenerAssetsTiendaSetup() {
  return wrapGet(
    api.get("/api/tienda/setup/assets"),
    "No se pudieron cargar los assets."
  );
}

export function actualizarAssetsTiendaSetup(body) {
  return wrapPut(
    api.put("/api/tienda/setup/assets", body),
    "No se pudieron guardar los assets."
  );
}

export function obtenerTiendaInicioSetup() {
  return wrapGet(
    api.get("/api/tienda/setup/inicio"),
    "No se pudo cargar la pantalla de inicio."
  );
}

export function guardarTiendaInicioSetup(body) {
  return api
    .put("/api/tienda/setup/inicio", body)
    .then((response) => ({
      ok: true,
      data: response.data?.data ?? null,
      message: response.data?.message || "Guardado correctamente.",
    }))
    .catch((error) => ({
      ok: false,
      data: null,
      message: error?.message || "No se pudo guardar la pantalla de inicio.",
    }));
}

export function subirCarruselImagenTiendaSetup(file) {
  const fd = new FormData();
  fd.append("carrusel_imagen", file);
  return api
    .post("/api/tienda/setup/inicio/carrusel-imagen", fd)
    .then((response) => ({
      ok: true,
      data: response.data?.data ?? null,
      message: response.data?.message || "",
    }))
    .catch((error) => ({
      ok: false,
      data: null,
      message: error?.message || "No se pudo subir la imagen del carrusel.",
    }));
}

export function guardarTiendaCarruselSetup(body) {
  return api
    .put("/api/tienda/setup/inicio/carrusel", body)
    .then((response) => ({
      ok: true,
      data: response.data?.data ?? null,
      message: response.data?.message || "Carrusel guardado.",
    }))
    .catch((error) => ({
      ok: false,
      data: null,
      message: error?.message || "No se pudo guardar el carrusel.",
    }));
}
